export function usePagination() {
  const onLoadPage = (scrollToSection: string, paramInUrl: boolean): void => {
    const sectionSelector = scrollToSection === 'body' ? 'body' : scrollToSection
    if (sectionSelector) {
      const sectionElement = document.querySelector(sectionSelector)

      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
    if (paramInUrl) {
      // handle redirect url
    }
  }
  return {
    onLoadPage
  }
}
